import { render } from "./FinanceQuotes.vue?vue&type=template&id=519fd080"
import script from "./FinanceQuotes.vue?vue&type=script&lang=js"
export * from "./FinanceQuotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__